import catalogData from './dev-scenario-catalog.json';

const SCENARIOS = catalogData.scenarios;
const DEFAULT_SCENARIO = catalogData.defaultScenario;
const FORCE_UPGRADE_SCENARIO = catalogData.forceUpgradeScenario;

const isSupportedScenario = (scenario) => {
    return SCENARIOS.some((entry) => entry.id === scenario);
};

const scenarioCatalog = {
    SCENARIOS,
    DEFAULT_SCENARIO,
    FORCE_UPGRADE_SCENARIO,
    isSupportedScenario,
};

export { SCENARIOS, DEFAULT_SCENARIO, FORCE_UPGRADE_SCENARIO, isSupportedScenario };

export default scenarioCatalog;
